<template>
	<div class="guide-item" :class="{ active }">
		<!--  <div
      class="cover"
      :style="{ backgroundImage: `url(${data.actionPicture})` }"
    ></div> -->
		<div class="cover" :style="{ backgroundImage: `url(${data.image})` }">
			<img class="img" v-if="!locked" src="../../assets/player-icon.png"
				@click="goPlayer(data)" />

		</div>

		<div class="d-flex pt-10 pb-10">
			<div class="title d-flex__item">
				{{ data.name }}
			</div>
			<div class="location" @click="viewPos">位置</div>
		</div>
		<Player @play-complete="$emit('play-complete')" ref="player" :product="product"
			@play="$emit('play', data.id)" :data="data" :is_buy="is_buy" :is_try="data.is_try" />
			<center v-if="data.is_indoor" style="margin-top: 10px;">
				<div class="mx__btn mx__btn--ok" @click="toZT()">进入展厅讲解</div>
			</center>
	</div>
</template>

<script>
	import mdx from "modax";
	import Player from "./player";


	export default {
		props: {
			data: Object,
			is_buy: Number,
			is_try: Number,
			active: Boolean,
			product: Object,
		},
		components: {
			Player
		},
		computed: {
			locked() {
				return true;
			},
		},
		data() {
			return {
				progress: 0,
				status: 0,
				isMp3: false,

			}
		},
		mounted() {
			this.$root.$on("view-dot", ({
				id,
				toggle,
				triggerByUser
			}) => {
				if (this.data.id === id) {
					this.$el.scrollIntoView({
						behavior: "smooth",
						block: "center",
					});
					if (!this.$refs.player) {
						return;
					}
					if (!triggerByUser) {
						// 试听结束
						if (this.$refs.player.locked) {
							this.$emit("exp-end");
							return;
						}
					}
					toggle && this.$refs.player.play();
				}
			});


		},
		methods: {
			toZT(){
				console.log(this.data.id)
				this.$router.push({
					name: "ExplainZT",
					params: {
						id:this.data.vid
					},
				});
			},
			goPlayer(datainfo) {
				this.$emit("goPlayer", datainfo);
			},
			viewPos() {
				this.$store.commit('SET_JINGDIAN',this.data)
				this.$router.push({
					name: "Map"
				});
			},

		},


	};
</script>

<style lang="scss" scoped>
	.location {
		&::before {
			display: inline-block;
			content: "";
			width: 34px;
			height: 34px;
			background: url(~@/assets/location.png) no-repeat center;
			background-size: contain;
			vertical-align: text-bottom;
			margin-right: 10px;
		}
	}

	.guide-item {
		margin-bottom: 20px;
		padding: 20px;
		overflow: hidden;
		position: relative;
		z-index: 10;
		border-radius: 8px;
		background: #fff;
		&.active {
			box-shadow: 0 0 20px 10px #bb677a55;
		}
	}

	.cover {
		height: 270px;
		border-radius: 14px;
		background: #ccc no-repeat center;
		background-size: cover;
		justify-content: center;
		align-items: center;
		display: flex;

		img {
			width: 108px;
			height: 108px;
		}

	}

	.title {
		font-size: 32px;
		color: #222;
	}

	.bar {
		padding: 10px 0;
	}

	.time {
		color: #666;
		font-size: 24px;
	}
</style>
